module.exports = __webpack_public_path__ + "static/media/wf.5e6aa0d6.svg";